import * as environment from '../../../config/environment';

import { BaseAPI } from "../../BaseAPI";

class EvKatsayiDegerlemeOraniAPI extends BaseAPI {


    constructor() {
        const baseUrl = environment.API_URL + "EvkatsayiDegerlemeListe";
        super(baseUrl);
    }


    getEvKatsayiDegerlemeOraniListe(yili?: number) {

        return this.get("", { params: { yili: yili } });
    }

}
export default new EvKatsayiDegerlemeOraniAPI();